import Container from "@components/Atomic/Container/Container";
import { Link } from "@components/Link/Link";
import React from "react";
import tw from "twin.macro";
import ImageGridCard from "./ImageGridCard";
import { withImageGrid } from "./withImageGrid";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";

const Wrapper = styledWithInvalidProps("div")(
  ({ spacing, cols }: { spacing?: string; cols: number }) => [
    tw`w-full max-w-full`,
    cols === 1 && spacing
      ? tw`max-w-2xl mx-auto px-giga sm:px-tera md:px-exa xl:px-[288px]`
      : null,
    cols === 2 && spacing
      ? tw`max-w-2xl mx-auto px-mini sm:px-3-6 md:px-tera xl:px-exa`
      : null,
    cols > 2 && spacing
      ? tw`max-w-2xl mx-auto px-mini sm:px-3-6 md:px-tera`
      : null,
  ],
);
const CardWrapper = tw.div`
  flex flex-wrap
`;
const TitleSection = tw.div`
  block
`;
const Title = tw.h2`
  text-h2 leading-h2 mb-mini text-center font-display md:text-h1 xl:text-[56px] md:leading-h4 md:mb-midi
`;
const CTAWrapper = tw.div`
  flex justify-center
`;
const StyledLink = tw(Link)`
  inline-block md:hidden text-body pb-pico mb-maxi border-b
`;

const ImageGrid = withImageGrid(
  ({
    spacing,
    link,
    title,
    cols,
    contents,
    background,
    showTitle,
    handleClick,
    textColour,
    styles,
  }) => {
    return (
      <Container
        styles={styles}
        legacy={!styles?.length}
        background={background}
        textColour={textColour}
        data-component-type="section-image-grid"
      >
        {contents ? (
          <Wrapper spacing={spacing} cols={cols}>
            {showTitle ? (
              <TitleSection data-testid="title-section">
                {title && <Title>{title}</Title>}
                {link?.url ? (
                  <CTAWrapper>
                    <StyledLink onClick={handleClick} to={link?.url}>
                      {link?.title}
                    </StyledLink>
                  </CTAWrapper>
                ) : null}
              </TitleSection>
            ) : null}
            <CardWrapper>
              <ImageGridCard
                spacing={spacing}
                cols={cols}
                contents={contents}
                handleClick={handleClick}
                textColour={textColour}
              />
            </CardWrapper>
          </Wrapper>
        ) : null}
      </Container>
    );
  },
);

export default ImageGrid;
